import React from 'react';

import SearchBar from './SearchBar';
import styles from './SearchBar.module.scss';

const DesktopSearchBar = (): React.JSX.Element => (
    <div
        className={styles.desktopSearchBar}
        data-zta="header-search-bar-desktop">
        <SearchBar device="desktop" />
    </div>
);

export default DesktopSearchBar;
